export function dealFreeze(col, row, table) {
    table.frozenColCount > 0 ? col !== table.frozenColCount - 1 ? table.setFrozenColCount(col + 1) : table.setFrozenColCount(0) : table.setFrozenColCount(col + 1);
}
//# sourceMappingURL=index.js.map
